import React, { useState } from 'react';
import { useHistory } from 'react-router';

// mui
import { Grid, MenuItem, TextField } from '@mui/material';

// block groups
import TableWithSearch from '../../../../../blockGroups/table/TableWithSearch/TableWithSearch.blockgroup';

// utils
import { cleanCrewMembersData } from './CrewListTable.collection.utils';
import { useTableSort } from '../../../../../shared/hooks/useTableSort';
import { useTableFilter } from '../../../../../shared/hooks/useTableFilter';

const crewSearchFieldOptions = [
    {value: "name", title: "Name"},
    {value: "phone", title: "Phone"},
    {value: "email", title: "Email"},
    {value: "classification", title: "Classification"}
];

const crewFilterFieldOptions = [
    { value: "active", title: "Active" },
    { value: "inactive", title: "Inactive" },
    { value: "all", title: "All" },
]

const crewColumnConfigs = [
    { 
        name: "name", 
        title: "Name", 
        objectFieldsToDisplay: ["name"],
        objectFieldsDelimeter: "", 
        width: 250, 
        useNestedObject: true 
    },
    { 
        name: "classification", 
        title: "Classification", 
        objectFieldsToDisplay: ["classification"],
        objectFieldsDelimeter: "", 
        width: 250, 
        useNestedObject: true 
    },
    { 
        name: "phone", 
        title: "Phone", 
        objectFieldsToDisplay: ["phone"],
        objectFieldsDelimeter: "", 
        width: 250, 
        useNestedObject: true 
    },
    { 
        name: "email", 
        title: "Email", 
        objectFieldsToDisplay: ["email"],
        objectFieldsDelimeter: "", 
        width: 250, 
        useNestedObject: true 
    },
];

const CrewListWithSearch = ({ data = { allCrewMembers: []}, loading, error, onAddClick, pageProps }) => {console.log("Graphql Data Received:", data);
    const history = useHistory()
    const filterBy = useTableFilter(pageProps.location.search, "active")
    const sortModel = useTableSort(pageProps.location.search)
    const handleSortChange = (newSortModel) => {
        if(newSortModel.length > 0) {
            history.push(`/crew?sortField=${newSortModel[0].field}&sortDirection=${newSortModel[0].sort}&filterBy=${filterBy}`)
        } else {
            history.push(`/crew?sortField=${""}&sortDirection=${""}&filterBy=${filterBy}`)
        }
    }
    const setFilterBy = (newFilter) => {
        if(sortModel.length > 0) {
            history.push(`/crew?sortField=${sortModel[0].field}&sortDirection=${sortModel[0].sort}&filterBy=${newFilter}`)
        } else {
            history.push(`/crew?sortField=${""}&sortDirection=${""}&filterBy=${newFilter}`)
        }
    }

    const handleRowClick = (rowData) => {
        history.push(`crew/${'id' in rowData ? rowData.id : ""}`)
    }

    const cleanedData = [...cleanCrewMembersData(data.allCrewMembers, filterBy)]
    console.log("Cleaned Data Going to Table", cleanedData);

    const addButtonConfig = {
        text: "New Crew Member",
        onClick: onAddClick
    }
    return (<Grid container>
        <Grid item>
            <TextField 
                select
                size={'small'}
                value={filterBy}
                onChange={(e) => setFilterBy(e.target.value)}
                fullWidth
                sx={{ marginBottom: 4}}
            >
                {
                    crewFilterFieldOptions.map(option => {
                        return (<MenuItem key={option.value} value={option.value}>{option.title}</MenuItem>)
                    })
                }
            </TextField>
        </Grid>
        <TableWithSearch 
            rawData={cleanedData}
            loading={false}
            error={error}
            searchFieldOptions={crewSearchFieldOptions}
            columnConfigs={crewColumnConfigs}
            addButtonConfig={addButtonConfig}
            onRowClick={handleRowClick}
            sortModel={sortModel}
            onSortModelChange={handleSortChange}
            pageProps={pageProps}
        />
    </Grid>
        
    );
}

export default CrewListWithSearch;